import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Link, Redirect } from "react-router-dom";
import PublicLayout from './layouts/PublicLayout';
import PrivateLayout from './layouts/PrivateLayout';
import LoginPage from './pages/auth/LoginPage';
import RegistrationPage from './pages/auth/RegistrationPage';
import RegistrationOtp from './pages/otp/registrationOtp';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import ChangePasswordPage from "./pages/auth/ChangePasswordPage";
import EditProfile from "./pages/auth/editProfile";
import DashboardPage from './pages/dashboard/DashboardPage';
import PatientCode from './pages/patient-code/AddPatientCode';
import PatientOtp from './pages/otp/patientOtp';
import ProfileDetail from './pages/profile-detail/ProfileDetail';
import PatientPrescription from './pages/patient-prescription-list/PatientPrescription';
import PrescriptionDetail from './pages/patient-prescription-detail/PatientPrescriptionDetail';
import OtherPrescriptionDetail from './pages/patient-prescription-detail/OtherPrescriptionDetail';
import { ConnectedRouter } from 'connected-react-router';
import ContactUs from './pages/contact-us';
import Faqs from './pages/faqs';
import EditPatientProfile from './pages/profile-detail/EditProfile';
import PatientImmunization from './pages/patient-immunization/PatientImmunizations';
import PrescriptionPermission from './pages/patient-prescription-list/PrescriptionPermission';
import PatientCertificate from './pages/PatientCertificate';
import ScheduleAppointmentPage from './pages/appointment/ScheduleAppointmentPage'
import PatientAppointmentList from './pages/appointment/PatientAppointmentList'
import HistoricData from './pages/historic-data/HistoricData';
import CovidTestForm from './pages/covid/CovidTestForm';
import PreRegisterPatient from './pages/PreRegisterPatient';
import ThankYou from './pages/thank-you';
import PatientDialysis from './pages/patient-dialysis-detail/PatientDialysis';
import DeleteAccount from './pages/delete-account/DeleteAccount';

function NoMatch({ location }) {
  return (
    <section className="middle-wrapper v-center">
      <div className="container">
        <div className="page-404">
          <i className="page-404-icon"></i>
          <h3>Page Not Found {location.pathname}</h3>
          <p>Sorry, we couldn't find the page you were looking for</p>
          <Link to="/dashboard" className="btn">Go to Home</Link>
        </div>
      </div>
    </section>
  );
}

function App({ history, checked }) {
  return (
    <ConnectedRouter history={history}>
      {checked &&
        <Switch>
          <Redirect exact from="/" to="/login" />
          <PublicLayout path="/login" exact component={LoginPage} />
          <PublicLayout path="/registration" exact component={RegistrationPage} />
          <PublicLayout path="/verify" exact component={RegistrationOtp} />
          <PublicLayout path="/forgot-password" exact component={ForgotPasswordPage} />
          <PublicLayout path="/reset-password" exact component={ResetPasswordPage} />
          <PublicLayout path="/contact-us" exact component={ContactUs} />
          <PublicLayout path="/faqs" exact component={Faqs} />
          <PublicLayout path="/patient/pre-registered/create/:serviceProviderId/:userLocationId" exact component={PreRegisterPatient} />
          <PublicLayout path="/thank-you/:id" exact component={ThankYou} />
          
          <PrivateLayout path="/dashboard" exact component={DashboardPage} />
          <PrivateLayout path="/change-password" exact component={ChangePasswordPage} />
          <PrivateLayout path="/profile" exact component={EditProfile} />
          <PrivateLayout path="/patient-code" exact component={PatientCode} />
          <PrivateLayout path="/otp" exact component={PatientOtp} />
          <PrivateLayout path="/patients/:patientId" exact component={ProfileDetail} />
          <PrivateLayout path="/patients/:patientId/prescriptions" exact component={PatientPrescription} />
          <PrivateLayout path="/patients/:patientId/prescriptions/:prescriptionId" exact component={PrescriptionDetail} />
          <PrivateLayout path="/patients/:patientId/dialysis/:id" exact component={PatientDialysis}/>
          <PrivateLayout path="/patients/:patientId/other-prescriptions/:prescriptionId" exact component={OtherPrescriptionDetail} />
          <PrivateLayout path="/patients/:patientId/edit" exact component={EditPatientProfile} />
          <PrivateLayout path="/patients/:patientId/immunizations" exact component={PatientImmunization} />
          <PrivateLayout path="/patients/:patientId/prescription-permissions" exact component={PrescriptionPermission} />
          <PrivateLayout path="/patients/:patientId/certificates" exact component={PatientCertificate} />
          <PrivateLayout path="/patients/:patientId/historic-data" exact component={HistoricData} />
          <PrivateLayout path="/appointments/:type" exact component={ScheduleAppointmentPage} />
          <PrivateLayout path="/appointments" exact component={PatientAppointmentList} />
          <PrivateLayout path="/delete-account" exact component={DeleteAccount} />
          
          <Route path="/mobile/contact-us" exact component={ContactUs} />
          <Route path="/mobile/faqs" exact component={Faqs} />
          <PublicLayout path="/covid-test/:service_provider" exact component={CovidTestForm} />
          <Route component={NoMatch} />
        </Switch>}
    </ConnectedRouter>
  );
}

const mapStateToProps = state => ({
  checked: state.session.checked,
})

export default connect(mapStateToProps)(App);
